export const getSizedItemKey = (type: string, id: string) => `${type}-${id}`;
